import React from 'react';

import { staticConfig } from '../../config';

import { Auth } from './index';
import AccessCheck from './accesscheck';
import ClassicAuth from './classicauth/ClassicAuth';

export const Authentication: React.FC = ({ children }) => (
    <AccessCheck>{staticConfig.useNgdp ? <Auth>{children}</Auth> : <ClassicAuth>{children}</ClassicAuth>}</AccessCheck>
);
